<script>
    import DataProvider from './OrderDataProvider';

    export default {
        name: "OrderCalculator",
        mixins:[DataProvider],
        data() {
            return {
                orderCalculatedPrice: null,
                orderTotalPrice: null,
                orderTotalDiscount: null,
                orderCalculation: {
                    policies: {
                        discounts: [],
                        amount: [],
                        credit: [],
                        date: [],
                        prepayment: [],
                    }
                }

            }
        },
        computed: {
            policies() {
                return this.order ? this.order.policies : null;
            }
        },
        methods: {
            calculatePrice() {
                this.resetOrderCalculations();

                if(!this.orderProducts || !this.orderProducts.length) return false;

                let price = 0,
                    calculatedPrice = 0;
                this.orderProducts.forEach(item => {
                    price += item.calculatedPrice;
                });
                calculatedPrice = this.applyPolicies(price);
                calculatedPrice = this.applyDiscounts(calculatedPrice);

                this.setPrices({
                    totalDiscountAmount: this.orderCalculation.policies.discounts.length ? price - calculatedPrice : null,
                    priceSummary: price,
                    priceWithDiscount: this.orderCalculation.policies.discounts.length ? calculatedPrice : null
                });

                this.orderCalculatedPrice = calculatedPrice;
                this.orderTotalPrice = price;
            },
            applyDiscounts(price) {
                this.resetOrderDiscounts();

                if(!this.orderCalculation.policies.discounts.length) {
                    this.orderTotalDiscount = null;
                    this.setDiscounts();
                    return price;
                }

                const totalDiscount = this.orderCalculation.policies.discounts.reduce((a, b) => a + b);
                this.orderTotalDiscount = totalDiscount;
                this.setDiscounts();

                return price * (1 - totalDiscount / 100);
            },
            applyPolicies(price) {
                this.resetOrderActivePolicies();
                this.orderCalculation.policies.discounts = [];

                if(!this.policies) return price;

                price = this.applyAmountPolicy(price);
                price = this.applyDatePolicy(price);
                price = this.applyPaymentPolicy(price);

                return price;
            },
            applyAmountPolicy(price) {
                if(!this.policies.amountPolicy) return price;

                let currentPolicy = null;

                this.policies.amountPolicy.forEach(item => {
                    if(!item.minSum || item.minSum < price) currentPolicy = item;
                });

                if(currentPolicy) {
                    this.orderCalculation.policies.discounts.push(currentPolicy.discount);
                    this.orderCalculation.policies.amount.push(currentPolicy.id);
                    this.setActivePolicies({policies: {amount: this.orderCalculation.policies.amount}})
                }

                return price;
            },
            applyDatePolicy(price) {
                if(!this.policies.datePolicy || !this.date || this.date === -1 || this.date === 1) return price;

                let currentPolicy = null;

                this.policies.datePolicy.forEach(item => {
                    if(item.dates.length === 1) {
                        if (this.date <= item.dates[0]) currentPolicy = item;
                    } else if(item.dates.length === 2) {
                        if(this.date >= item.dates[0] && this.date <= item.dates[1]) currentPolicy = item;
                    }
                });

                if(currentPolicy) {
                    this.orderCalculation.policies.discounts.push(currentPolicy.discount);
                    this.orderCalculation.policies.date.push(currentPolicy.id);
                    this.setActivePolicies({policies: {dates: this.orderCalculation.policies.date}})
                }

                return price;
            },
            applyPaymentPolicy(price) {
                if(!this.policies.paymentPolicy || !this.paymentWay) return price;

                let currentPolicy = null;

                if(this.paymentWay === 'prepayment') {
                    if (this.policies.paymentPolicy.prepayment && this.policies.paymentPolicy.prepayment.discount) {
                        currentPolicy = this.policies.paymentPolicy.prepayment;

                        if(currentPolicy) {
                            this.orderCalculation.policies.discounts.push(currentPolicy.discount);
                            this.orderCalculation.policies.prepayment.push(currentPolicy.id);
                            this.setActivePolicies({policies: {prepayment: this.orderCalculation.policies.prepayment}})
                        }
                    }

                } else {
                    if(this.policies.paymentPolicy.credits && this.creditPolicy) {
                        currentPolicy = this.policies.paymentPolicy.credits.find(item => item.id === this.creditPolicy);
                        if(currentPolicy) {
                            this.orderCalculation.policies.discounts.push(currentPolicy.discount);
                            this.orderCalculation.policies.credit.push(currentPolicy.id);
                            this.setActivePolicies({policies: {credit: this.orderCalculation.policies.credit}})
                        }
                    }
                }

                return price;
            },
            resetOrderActivePolicies() {
                this.$store.commit('orderResetActivePolicies', this.order.seller.id);
            },
            resetOrderDiscounts() {
                this.$store.commit('orderResetDiscounts', this.order.seller.id);
            },
            setActivePolicies(data) {
                data.sellerID = this.order.seller.id;
                this.$store.commit('orderSetActivePolicies', data);
            },
            setDiscounts() {
                const data = {};
                data.sellerID = this.order.seller.id;
                data.discounts = this.orderCalculation.policies.discounts;

                this.orderTotalDiscount = data.discounts.length ? data.discounts.reduce((a, b) => a + b) : null;
                this.$store.commit('orderSetDiscounts', data);
            },
            setPrices(data) {
                data.sellerID = this.order.seller.id;
                this.$store.commit('orderSetPrice', data);
            },
            resetOrderCalculations() {
                this.orderCalculation.policies = {
                    discounts: [],
                    amount: [],
                    credit: [],
                    date: [],
                    prepayment: [],
                };
                this.orderTotalDiscount = null;
                this.orderTotalPrice = null;
                this.orderCalculatedPrice = null;

            }
        }
    }
</script>

<style scoped>

</style>
